import Container from "components/general/Container";
import Section from "components/general/Section";
import { Box, Button, Typography, VStack } from "components/ui";
import React from "react";
import { PageButton } from "components/page/parts/PageButton"; // Assuming these can be used generally
import { PageText } from "components/page/parts/PageText"; // Assuming these can be used generally
import { Link } from "expo-router";

// Define props for the CallToAction component
interface CallToActionProps {
	type: "Contact Us" | "Download Brochure" | "Request a Quote" | "Book a Meeting";
}

export const CallToAction: React.FC<CallToActionProps> = ({ type = "Contact Us" }) => {
	let content = null;
	let buttonElement = null;
	if (type === "Contact Us") {
		content = (
			<VStack mb={24} gap={12} alignItems="center" justifyContent="center">
				<Typography.H3 color="white">Ready to experience the Abco service difference?</Typography.H3>
				<Typography color="white">Explore how our tailored solutions can help your business. Our team of dedicated experts are ready to assist you throughout every stage of the process.</Typography>
				{/* <Typography color="white">Join thousands of satisfied customers who trust Abco for their cleaning needs. Let’s work together to create a cleaner tomorrow.</Typography> */}
			</VStack>
		);
		buttonElement = (
			<Link href={"/contact"} asChild>
				<PageButton size="large" variant="primary" text="Get in touch with us" type="enquireForm" />
				{/* <Typography color="white">Get in touch with us</Typography> */}
				{/* </PageButton> */}
			</Link>
		);
	}

	return (
		<Box bg="$primarydark" py={12}>
			<Container>
				<Section gap={24} alignItems="center" bg="transparent">
					<Box>{content}</Box>
					<Box>{buttonElement}</Box>
				</Section>
			</Container>
		</Box>
	);
};

export default CallToAction;
